/* eslint-disable import/prefer-default-export */
export const COMPETITION_ACTION_TYPES = {
  SET_SELECTED_COMPETITION: 'competition/SET_SELECTED_COMPETITION',
};
